// este es mi archivo con funciones globales
import moment from 'moment/moment';
import Vue from 'vue';

Vue.mixin({
  methods: {
    havePermission(model, method){return this.$user.roles[0].permissions.some(el => el.name == `${model}.${method}`);},
    /** Generate new notification */
    async customNotification(icon=null, title=null, text=null, showCancelButton=null){
			const Toast = Swal.mixin({
					toast: true,
					position: 'top-end',
					showConfirmButton: true,
					timerProgressBar: true,
					didOpen: (toast) => {
							toast.addEventListener('mouseenter', Swal.stopTimer)
							toast.addEventListener('mouseleave', Swal.resumeTimer)
					}
			});

			let notificationResponse = await Toast.fire({
					'icon'            : icon,
					'title'           : title,
					'text'            : text,
					'showCancelButton': showCancelButton,
			});

			return {
				toast 	: Toast,
				response: notificationResponse
			};
    },
		/**
		 * In case the element have the "showDeleteOpt" class, this method would remove it.
		 * Otherwise, it would add it
		 * @params event
		 */
    addOrRemoveDeleteOptClass(e){
			let element = document.getElementById(e.target.id);
			element.classList.contains('showDeleteOpt') && e.type == "mouseleave"
				? element.classList.remove('showDeleteOpt')
				: element.classList.add('showDeleteOpt')
		},

    formatNumberToDecimal(number) {
			return (number === null || number === undefined)
				? "0.00"
				: number.toFixed(2);
    },

    dateToDBFormat(date){
			return moment(date,['DD-MM-YYYY']).format('YYYY-MM-DD');
    },

    /**
     * @param {number} newValue
     * @returns Format Number. Ex: 000 000 0000.
     */
    formatPhoneNumber(newValue){
			if (newValue.length == 10 &&  newValue[3] != " ") {
				return newValue.insertAt(3," ").insertAt(7," ");
			}

			if (newValue.length == 4 && newValue[3] == " ") {
				newValue = newValue.removeAt(3);
			}
			else if (newValue.length == 3 || newValue.length == 4) {
				newValue = newValue.insertAt(3," ");
			}

			if (newValue.length == 8 && newValue[7] == " ") {
				newValue = newValue.removeAt(7);
			}
			else if (newValue.length == 7 && newValue[7] != " ") {
				newValue = newValue.insertAt(7," ");
			}
			return newValue;
    },

    enterAsTab(e){
			if(e.keyCode != 13) return;
			e.preventDefault();
			const keyboardfocusableElements = document.querySelectorAll(
				'button[tabbable], select, input:not([readonly], textarea, [tabindex]:not([tabindex="-1"])'
			)
			let arrayOfElements = Array.from(keyboardfocusableElements);
			arrayOfElements     = arrayOfElements.filter((e) => e.offsetWidth > 0 && e.offsetHeight > 0);
			let index = arrayOfElements.indexOf(e.target);
			let $el   = arrayOfElements[index + 1];

			if ($el) {
				if (typeof $el.focus === "function") $el.focus();
				if (typeof $el.select === "function") $el.select();
			}
    },

    selectText(e) {
      let input = e.target;
      input.focus();
      input.select();
    },
    /**
     * Convert first leter to upperCase
     * @param {string} s string
     * @returns String
    	*/
    capitalize(s) {
			if (s == undefined || s == null) return '';
			return s.charAt(0).toUpperCase() + s.slice(1);
    },

    formatNumber: function (number){
        if(number == "" || number == undefined || isNaN(number)) return 0;
        return Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')/* .replace(".00","") */;
    },

    dateTimeFormat: function(dateTime){
        return moment(dateTime).locale('es').format('LLL');
    },

    print(){
      window.print();
    },

    focus(name) {
      setTimeout(() => {
        document.getElementById(name).focus();
      }, "500");
    },

    /**
     * Open add or edit modal
     */
    openModal(modalId) {
      const myModal = new bootstrap.Modal(document.querySelector(`#${modalId}`), {});
      myModal.show();
    },
  },
});
